import styled from "@emotion/styled";
import colors from "/styles/colors";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledMultipleDirectoryImagesTemplate = styled.div`
  .directories-list-wrapper {
    background-color: #f5f5f5;
    padding-top: 80px;
  }

  nav.navbar {
    background-color: ${colors["white"]} !important;
  }

  .directory-list-item-title {
    max-width: 1320px;
    width: calc(100vw - 32px);

    margin: 0 auto 16px auto;
    padding: 16px 0;
    border-width: 0 0 1px 0;
    border-style: solid;

    font-size: 2vw;
    font-weight: 400;
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .directory-list-item-title {
      max-width: calc(100% - 48px);
      font-size: 1.375rem;
    }
  }
`;
export const StyledEmptyResult = styled.div`
  padding-bottom: 80px;
`;
